
import {FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {FC, ReactElement, ReactNode, useMemo} from "react";
import { EmployActionsModalWrapper } from "../../sendProjects/employStyles";
import { ProjectsSearchBar } from "shared/components/projectsSearchBar/projectsSearchBar";
import { SortingTypeIndex } from "shared/constants/sortingType";
import { MobileFilterSort } from "shared/pages/explore/styles";
import { SortIcon } from "shared/icons";
import { ActionsTitle } from "shared/modals/sendProjects/styles";
import { HSESansTitleCoolEpicMegoGena } from "_deziiign/hsedesign/components/IndexTitle";
import { ExploreButtonHollow } from "shared/pages/explore/styles";
import styled from "styled-components";
import { LayoutConst } from "core";
import { AppTester } from "supporting";

interface SendProjectsTitleProps {
    leftBar: ReactElement;
    onMobileSortingClick: () => void;
    onSortingChange: (s: SortingTypeIndex) => void;
    onBackClick?: () => void;
    onAddNewMemebersClick?: () => void;
    sorting: SortingTypeIndex;
    children?: ReactNode;
    title?: string;
    showAddButton?: boolean;
    isGroupModal?: boolean;
    hideSorting?: boolean;
}

const AddButtonWrapper = styled(FlexBox)`
    button {
        margin-right: 0 !important; 
        @media(max-width: ${LayoutConst.screen.md}px) {
            width: 270px !important;
            height: 46px !important;
            max-width: 270px !important;
        }
        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            width: 100% !important;
            height: 46px !important;
            max-width: none !important;
        }
    }
`

export const GroupHeader: FC<SendProjectsTitleProps> = ({leftBar, onMobileSortingClick, sorting, hideSorting, onSortingChange, onBackClick, onAddNewMemebersClick, children, title, showAddButton, isGroupModal}) => {

    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const is733 = useBreakpoint(LayoutConst.screen.s - 1);
    const isGeo = AppTester.isGeograffee();

    const searchBar = useMemo(
        () => (
            <ProjectsSearchBar
                isLoading={false}
                sorting={sorting}
                hideRightBar={false}
                hideLeftBar={true}
                hideRightButtons
                onSortingChange={onSortingChange}
                isTagPage={false}
                sortingMethods={isGroupModal ? [1,3] : [1,2]}
            />
        ),
        [
            sorting,
            onSortingChange,
            isGroupModal
        ],
    );

    return <EmployActionsModalWrapper direction="column" gy={20}>
         <ActionsTitle justify='space-between' justifyMobile='space-between' direction='row' style={{ marginBottom: is733 ? 0 : '12px'}} >
            <HSESansTitleCoolEpicMegoGena
                uppercase={true}
                style={{ cursor: 'pointer' }}
                onClick={onBackClick}
                isDark={isGeo}
                isAlumni={false}
                isModal
            >
                {title || ''}
            </HSESansTitleCoolEpicMegoGena>
        </ActionsTitle>
        {showAddButton && (
            <AddButtonWrapper >
                <ExploreButtonHollow onClick={onAddNewMemebersClick}>{t('teams.modal.action_buttons.add_members')}</ExploreButtonHollow>
            </AddButtonWrapper>
        )}
        {(!!leftBar || !hideSorting )&& (
            <FlexBox width={'100%'} direction='row' justify='space-between' align='center'>
                {leftBar && leftBar}
                {!hideSorting &&
                    <>
                        {isMobile ? (
                            <MobileFilterSort onClick={onMobileSortingClick}>
                                <SortIcon/>
                                {t(`sorting_type.${sorting == 1 ? 'latest' : 'popular'}`)}
                            </MobileFilterSort>
                        ) : searchBar}
                    </>
                }
            </FlexBox>
        )}

        {children}
    </EmployActionsModalWrapper>
}
import {FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {FC, ReactElement, ReactNode, useMemo} from "react";
import { EmployActionsModalWrapper } from "../../sendProjects/employStyles";
import { ProjectsSearchBar } from "shared/components/projectsSearchBar/projectsSearchBar";
import { SortingTypeIndex } from "shared/constants/sortingType";
import { MobileFilterSort } from "shared/pages/explore/styles";
import { SortIcon } from "shared/icons";
import { ActionsTitle } from "shared/modals/sendProjects/styles";
import { HSESansTitleCoolEpicMegoGena } from "_deziiign/hsedesign/components/IndexTitle";
import { ExploreButtonHollow } from "shared/pages/explore/styles";
import styled from "styled-components";
import { LayoutConst } from "core";
import { AppTester } from "supporting";

interface SendProjectsTitleProps {
    leftBar: ReactElement;
    onMobileSortingClick: () => void;
    onSortingChange: (s: SortingTypeIndex) => void;
    onBackClick?: () => void;
    onAddNewMemebersClick?: () => void;
    sorting: SortingTypeIndex;
    children?: ReactNode;
    title?: string;
    showAddButton?: boolean;
    isGroupModal?: boolean;
    hideSorting?: boolean;
}

const AddButtonWrapper = styled(FlexBox)`
    button {
        margin-right: 0 !important; 
        @media(max-width: ${LayoutConst.screen.md}px) {
            width: 270px !important;
            height: 46px !important;
            max-width: 270px !important;
        }
        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            width: 100% !important;
            height: 46px !important;
            max-width: none !important;
        }
    }
`

export const GroupHeader: FC<SendProjectsTitleProps> = ({leftBar, onMobileSortingClick, sorting, hideSorting, onSortingChange, onBackClick, onAddNewMemebersClick, children, title, showAddButton, isGroupModal}) => {

    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const is733 = useBreakpoint(LayoutConst.screen.s - 1);
    const isGeo = AppTester.isGeograffee();

    const searchBar = useMemo(
        () => (
            <ProjectsSearchBar
                isLoading={false}
                sorting={sorting}
                hideRightBar={false}
                hideLeftBar={true}
                hideRightButtons
                onSortingChange={onSortingChange}
                isTagPage={false}
                sortingMethods={isGroupModal ? [1,3] : [1,2]}
            />
        ),
        [
            sorting,
            onSortingChange,
            isGroupModal
        ],
    );

    return <EmployActionsModalWrapper direction="column" gy={20}>
         <ActionsTitle justify='space-between' justifyMobile='space-between' direction='row' style={{ marginBottom: is733 ? 0 : '12px'}} >
            <HSESansTitleCoolEpicMegoGena
                uppercase={true}
                style={{ cursor: 'pointer' }}
                onClick={onBackClick}
                isDark={isGeo}
                isAlumni={false}
                isModal
            >
                {title || ''}
            </HSESansTitleCoolEpicMegoGena>
        </ActionsTitle>
        {showAddButton && (
            <AddButtonWrapper >
                <ExploreButtonHollow onClick={onAddNewMemebersClick}>{t('teams.modal.action_buttons.add_members')}</ExploreButtonHollow>
            </AddButtonWrapper>
        )}
        {(!!leftBar || !hideSorting )&& (
            <FlexBox width={'100%'} direction='row' justify='space-between' align='center'>
                {leftBar && leftBar}
                {!hideSorting &&
                    <>
                        {isMobile ? (
                            <MobileFilterSort onClick={onMobileSortingClick}>
                                <SortIcon/>
                                {t(`sorting_type.${sorting == 1 ? 'latest' : 'popular'}`)}
                            </MobileFilterSort>
                        ) : searchBar}
                    </>
                }
            </FlexBox>
        )}

        {children}
    </EmployActionsModalWrapper>
}